<template>
  <div>
    <div class="picker w-980 relative-view">
      <!-- 提货方式选择 -->
      <picker-apply-choose ref="pickerApplyChoose"></picker-apply-choose>
      <!-- 收货人信息 -->
      <picker-apply-deliver :deliveryInfo="chooseData.deliveryInfo"></picker-apply-deliver>
      <!-- 列表 -->
      <picker-apply-list :choose-data="chooseData"></picker-apply-list>
      <!-- 底部 -->
      <picker-apply-submit
        :choose-data="chooseData"
        :can-submit="isAllDone()"
        @submitApply="submitApply"
      ></picker-apply-submit>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="successDialog"
      width="440px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <span>提单创建成功，可在“发货管理-发货”中进行发货。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="toBack">继续提货</el-button>
        <el-button type="primary" @click="toPicker">去发货</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PickerApplyDeliver from '../picker/components/picker-apply-deliver'
import PickerApplyChoose from '../picker/components/picker-apply-choose'
import PickerApplyList from '../picker/components/picker-apply-list'
import PickerApplySubmit from '../picker/components/picker-apply-submit'

export default {
  name: 'PickerApply',
  components: {
    PickerApplyDeliver,
    PickerApplyChoose,
    PickerApplyList,
    PickerApplySubmit
  },
  data() {
    return {
      successDialog: false, // 提单创建成功弹出
      infoList: [],
      chooseData: {}, // 想要提货的商品列表
      onLoadPickerApplyChoose: false, // 应为用到了ref, 但ref不是响应的, 通过一个属性控制
      deliveryInfo: {} // 收货人信息
    }
  },
  async created() {
    await this.getChooseData()
  },
  mounted() {
    // 渲染完就标记, 可以取到ref
    this.onLoadPickerApplyChoose = true
  },
  methods: {
    async getChooseData() {
      // mocks数据
      // this.chooseData = { "depositoryOrderContexts": [ { "depositoryId": 555, "depositoryName": "紫东库", "itemResultList": [ { "depositoryId": 555, "icon": "o_w-9428594b34f14e958c5bc031a5d6ab41.jpg", "orderCreateTime": 1574844705000, "orderId": 437212002, "outId": 1906, "outType": 2, "perProductWeight": "120000.00", "preProductNum": 1, "preProductWeight": "120000.00", "productId": 253810, "productSkuId": 0, "productTitle": "不锈钢热轧卷 test 213213 安阳钢厂 6Q 4D", "projectCustomerId": "null", "projectId": 0, "sellerOrgName": "Josen专卖店", "shopId": 1504, "skuTitle": "12吨 理计", "subBizType": 200, "version": 3, "weightUnitValue": "TON" } ], "orderCreateTime": 1574844705000, "orderId": 437212002, "preProductNum": 1, "preProductWeight": "120000.00" }, { "depositoryId": 3, "depositoryName": "建材超市", "itemResultList": [ { "bundleNo": "", "depositoryId": 3, "icon": "o_w-2e12d73d2293428f92a31474958d501b.jpg", "orderCreateTime": 1568082131000, "orderId": 200452002, "outId": 4086144, "outType": 1, "perProductWeight": "238900.00", "preProductNum": 1, "preProductWeight": "238900.00", "productId": 13803, "productSkuId": 4086144, "productSubTitle": "", "productTitle": "三级螺纹钢 钢材 100*100 武钢", "projectCustomerId": "null", "projectId": 0, "sellerOrgName": "招行测试", "shopId": 57, "skuTitle": "23.890吨 抄码", "subBizType": 0, "version": 1, "weightUnitValue": "TON" } ], "orderCreateTime": 1568082131000, "orderId": 200452002, "preProductNum": 1, "preProductWeight": "238900.00" }, { "depositoryId": 3, "depositoryName": "建材超市", "itemResultList": [ { "bundleNo": "", "depositoryId": 3, "icon": "o_w-2e12d73d2293428f92a31474958d501b.jpg", "orderCreateTime": 1568082124000, "orderId": 200442002, "outId": 4086144, "outType": 1, "perProductWeight": "238900.00", "preProductNum": 1, "preProductWeight": "238900.00", "productId": 13803, "productSkuId": 4086144, "productSubTitle": "", "productTitle": "三级螺纹钢 钢材 100*100 武钢", "projectCustomerId": "null", "projectId": 0, "sellerOrgName": "招行测试", "shopId": 57, "skuTitle": "23.890吨 抄码", "subBizType": 0, "version": 1, "weightUnitValue": "TON" } ], "orderCreateTime": 1568082124000, "orderId": 200442002, "preProductNum": 1, "preProductWeight": "238900.00" } ], "totalNum": 3, "totalWeight": "597800.00" }
      let itemParamList = JSON.parse(decodeURIComponent(this.$route.query.itemParamList))
      let { success, data } = await this.$post('lgcenter.getCreateDispatchOrderContext', {
        dispatchOrderContextParamDTO: {
          itemParamList,
          mark: 2, // 1.买家 , 2.卖家
          // sellerId: this.$store.getters.uid,
          sellerOrgId: this.$store.state.user.userCurrentOrg.id
        }
      })
      if (success && data[0].success && data[0].data) {
        this.chooseData = data[0].data || null
      } else {
        this.$message.error(data[0].message)
      }
    },
    // 提交提货函
    async submitApply(obj) {
      // 先新增提货人信息
      let { isSelf, chooseOrgId, pickerRemark } = this.$refs.pickerApplyChoose
      if (isSelf) {
        await this.$refs.pickerApplyChoose.addDispatcher()
        // 校验提货人id, 是否成功添加
        let dispatcherId = this.$refs.pickerApplyChoose.dispatcherId
        if (!dispatcherId || dispatcherId === 0) {
          return
        }
      }
      let dispatchOrderCreateParams = {
        dispatcherId: this.$refs.pickerApplyChoose.dispatcherId,
        transferOrgId: chooseOrgId,
        buyerRemark: pickerRemark,
        itemParamList: JSON.parse(decodeURIComponent(this.$route.query.itemParamList)),
        mark: 2 // 1.买家 2.卖家
      }
      // 提交提货函
      let { data } = await this.$post('lgcenter.createDispatchOrderV2', {
        dispatchOrderCreateV2: dispatchOrderCreateParams
      })
      if (data[0].success) {
        this.successDialog = true
      } else {
        this.$message.error(data[0].message)
      }
    },
    // 这里取反, 因为传给disable
    isAllDone() {
      if (!this.onLoadPickerApplyChoose) return true
      let { isDone } = this.$refs.pickerApplyChoose
      return !isDone
    },
    toPicker() {
      this.$store.commit('tagsView/DEL_VISITED_VIEW', { path: this.$route.path })
      // 跳转提单列表
      this.$router.replace({ name: 'picker-list' })
    },
    toBack() {
      this.$store.commit('tagsView/DEL_VISITED_VIEW', { path: this.$route.path })
      // 返回提货列表
      this.$router.go(-1)
    },
    // 转换表情符号及空格
    utf16toEntities(str) {
      if (str) {
        str = str.replace(/[\ud800-\udbff][\udc00-\udfff]/g, '') // 表情替换为?
        str = str.replace(/(^\s*)|(\s*$)/g, '') // 空格取消
        return str
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.picker {
  .choose {
    margin-bottom: 30px;
    .choose-title {
      padding: 10px 25px 10px 25px;
      display: flex;
      align-items: center;
    }
    &.disable {
      background-color: #fff;
      border: 2px solid #f5f7fa;
      span {
        color: #999;
      }
    }
  }
}
</style>
